import type { BudgetReturnContextContract, BudgetReturnResultContract } from "../api/adapters";
import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import { mapBudgetReturnContext, mapBudgetReturnResult } from "../api/adapters";
import type { CustomerQuoteBudgetReturnCommand } from "../types/budgetReturn";

/** 校验公共响应，再交由业务适配器映射。 */
function unwrap<T>(response: ApiEnvelope<T>): T {
  if (response.code !== "OK" || response.data == null) throw new Error("核价退回请求失败，请稍后重试");
  return response.data;
}

/** 查询精确绑定核价和接收计调，不触发任何通知。 */
export async function fetchCustomerQuoteBudgetReturnContext(customerQuoteId: string) {
  const response = await httpClient.get<ApiEnvelope<BudgetReturnContextContract>>(`/customer-quotes/${customerQuoteId}/budget-return-context`);
  return mapBudgetReturnContext(unwrap(response.data));
}

/** 幂等取消精确核价定稿并发送本次退回通知。 */
export async function returnCustomerQuoteBudget(customerQuoteId: string, command: CustomerQuoteBudgetReturnCommand) {
  const response = await httpClient.post<ApiEnvelope<BudgetReturnResultContract>>(`/customer-quotes/${customerQuoteId}/budget-returns`, {
    request_id: command.requestId, expected_quote_revision: command.expectedQuoteRevision,
    expected_source_revision: command.expectedSourceRevision, reason: command.reason,
  });
  return mapBudgetReturnResult(unwrap(response.data));
}

/** 补发原退回事件失败的通知，不再次取消定稿。 */
export async function retryCustomerQuoteBudgetReturn(customerQuoteId: string, returnId: string) {
  const response = await httpClient.post<ApiEnvelope<BudgetReturnResultContract>>(`/customer-quotes/${customerQuoteId}/budget-returns/${returnId}/retry-notifications`);
  return mapBudgetReturnResult(unwrap(response.data));
}
